import React, { ReactNode } from 'react';

import type { SxProps } from '@mui/material';

import { styled, Box } from '@liscio/ui';

export interface AppHeaderWrapperProps {
  hideBorderBottom?: boolean;
  sx?: SxProps;
  children: ReactNode;
}

const Wrapper = styled(Box)(({ theme }) => ({
  // backgroundColor: theme.palette.grey[50], // I think we should change this too
  backgroundColor: theme.palette.common.white,
  borderBottom: `solid 1px ${theme.brandColors.sky}`,
  paddingLeft: '26px',
  paddingRight: '15px',
  paddingTop: '8px',
  paddingBottom: '8px',
}));

export const AppHeaderWrapper: React.FC<AppHeaderWrapperProps> = ({
  hideBorderBottom,
  sx,
  children,
}) => {
  return (
    <Wrapper
      sx={[
        { borderBottomWidth: hideBorderBottom ? 0 : '1px' },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Wrapper>
  );
};

export default AppHeaderWrapper;
